import { FormControl, InputLabel, MenuItem, Tooltip } from "@mui/material";
import React from "react";
import { Select } from "@mui/material";
import { formatDateRange, getDateRangeForFilter } from "../utils/utils";

const TimePeriodFilter = ({
  timeFilter,
  onChange,
}: {
  timeFilter: string;
  onChange: (value: any) => void;
}) => {
  return (
    <FormControl fullWidth size="small" sx={{ fontSize: "12px" }}>
      <InputLabel sx={{ fontSize: "12px" }}>Time Period</InputLabel>
      <Tooltip
        title={
          timeFilter === "today"
            ? `Today: ${formatDateRange(getDateRangeForFilter("today").start)}`
            : timeFilter === "thisWeek"
            ? `This Week: ${formatDateRange(
                getDateRangeForFilter("thisWeek").start,
                getDateRangeForFilter("thisWeek").end
              )}`
            : timeFilter === "last7days"
            ? `Last 7 Days: ${formatDateRange(
                getDateRangeForFilter("last7days").start,
                getDateRangeForFilter("last7days").end
              )}`
            : timeFilter === "lastWeek"
            ? `Last Week: ${formatDateRange(
                getDateRangeForFilter("lastWeek").start,
                getDateRangeForFilter("lastWeek").end
              )}`
            : timeFilter === "thisMonth"
            ? `This Month: ${formatDateRange(
                getDateRangeForFilter("thisMonth").start,
                getDateRangeForFilter("thisMonth").end
              )}`
            : timeFilter === "lastMonth"
            ? `Last Month: ${formatDateRange(
                getDateRangeForFilter("lastMonth").start,
                getDateRangeForFilter("lastMonth").end
              )}`
            : timeFilter === "financialYear"
            ? `Financial Year: ${formatDateRange(
                getDateRangeForFilter("financialYear").start,
                getDateRangeForFilter("financialYear").end
              )}`
            : timeFilter === "custom"
            ? ""
            : ""
        }
        placement="top"
      >
        <Select
          value={timeFilter}
          label="Time Period"
          onChange={(e) => onChange(e.target.value)}
          sx={{ fontSize: "12px" }}
        >
          <MenuItem value="" sx={{ fontSize: "12px", color: "text.secondary" }}>
            Select Time Period
          </MenuItem>
          <MenuItem value="today" sx={{ fontSize: "12px" }}>
            Today {formatDateRange(getDateRangeForFilter("today").start)}
          </MenuItem>
          <MenuItem value="thisWeek" sx={{ fontSize: "12px" }}>
            This Week{" "}
            {formatDateRange(
              getDateRangeForFilter("thisWeek").start,
              getDateRangeForFilter("thisWeek").end
            )}
          </MenuItem>
          <MenuItem value="last7days" sx={{ fontSize: "12px" }}>
            Last 7 Days{" "}
            {formatDateRange(
              getDateRangeForFilter("last7days").start,
              getDateRangeForFilter("last7days").end
            )}
          </MenuItem>
          <MenuItem value="lastWeek" sx={{ fontSize: "12px" }}>
            Last Week{" "}
            {formatDateRange(
              getDateRangeForFilter("lastWeek").start,
              getDateRangeForFilter("lastWeek").end
            )}
          </MenuItem>
          <MenuItem value="thisMonth" sx={{ fontSize: "12px" }}>
            This Month{" "}
            {formatDateRange(
              getDateRangeForFilter("thisMonth").start,
              getDateRangeForFilter("thisMonth").end
            )}
          </MenuItem>
          <MenuItem value="lastMonth" sx={{ fontSize: "12px" }}>
            Last Month{" "}
            {formatDateRange(
              getDateRangeForFilter("lastMonth").start,
              getDateRangeForFilter("lastMonth").end
            )}
          </MenuItem>
          <MenuItem value="financialYear" sx={{ fontSize: "12px" }}>
            Financial Year{" "}
            {formatDateRange(
              getDateRangeForFilter("financialYear").start,
              getDateRangeForFilter("financialYear").end
            )}
          </MenuItem>
          <MenuItem value="custom" sx={{ fontSize: "12px" }}>
            Custom Range
          </MenuItem>
        </Select>
      </Tooltip>
    </FormControl>
  );
};

export default TimePeriodFilter;
